import { useMemo } from 'react';
import { decodeQuestionText } from '../../utils/questionTextUtils';

export interface QuestionHtmlContentProps {
  html: string;
  className?: string;
  /** span 等のインライン要素として描画する場合 */
  as?: 'div' | 'span';
}

/**
 * 問題文・選択肢など HTML 入稿コンテンツをデコードして描画する。
 * 管理画面（tenant-elive）と同様に base64 エンコード HTML に対応する。
 */
export function QuestionHtmlContent({
  html,
  className = 'test-html-content',
  as = 'div',
}: QuestionHtmlContentProps) {
  const decodedHtml = useMemo(() => decodeQuestionText(html), [html]);
  const Tag = as;

  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: decodedHtml }}
    />
  );
}
